type VerifySecondFactorParams =
	| { code: string; recoveryCode?: never }
	| { code?: never; recoveryCode: string };

/** Carries exactly one of `code` or `recoveryCode`: the API rejects both together and any unknown key. */
class VerifySecondFactor {
	readonly code: string | undefined;
	readonly recoveryCode: string | undefined;

	constructor(params: VerifySecondFactorParams) {
		this.code = params.code;
		this.recoveryCode = params.recoveryCode;
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		if (this.code !== undefined) {
			return { code: this.code };
		}

		return { recoveryCode: this.recoveryCode };
	}
}

export default VerifySecondFactor;
